import { render, staticRenderFns } from "./SupplierPortalPurchaseOrderTab.vue?vue&type=template&id=90acdf08"
import script from "./SupplierPortalPurchaseOrderTab.vue?vue&type=script&lang=js"
export * from "./SupplierPortalPurchaseOrderTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports